import React from 'react';
import styled from '@benzinga/themetron';

export const ArticleIFrame: React.FC<{ articleBody: string }> = ({ articleBody }) => {
  return (
    <IFrameDivWrapper className="flex flex-grow flex-1 items-stretch w-full mx-auto">
      <IFrameArticle className="article-body w-full flex-1" srcDoc={articleBody} />
    </IFrameDivWrapper>
  );
};

const IFrameDivWrapper = styled.div`
  min-height: 90vh;
`;
const IFrameArticle = styled.iframe``;
